<div class="container mb-100" *ngIf="isActive">
  <adp-setting key="Global_Salesforce_Invitation_Email_Template_Key"></adp-setting>
  <adp-setting key="Global_Salesforce_Invitation_Email_Template_Key_Model"></adp-setting>
  <adp-setting key="Global_Salesforce_Invitation_Email_Template_Key_Prod"></adp-setting>
  <div class="header-title-container">
    <p><adp-label labelKey="Account_Manage_Members_Heading"></adp-label></p>
  </div>
  <div class="mt-20 mb-20">
    <div class="mt-20 manage-members-desc">
      <adp-label labelKey="Account_Manage_Members_Description"></adp-label>
    </div>
    <div class="manage-account">
      <div class="manage-account-add-member-link">
        <button
          *ngIf="familyMemberList?.length < 40; else maximumMembersMessage"
          class="link"
          color="primary"
          (click)="openAddFamilyMemberModal()"
          [gtmClick]="getViewLabel('Account_Manage_Members_AddMemberButton')">
          <adp-label labelKey="Account_Manage_Members_AddMemberButton"></adp-label>
        </button>
      </div>
    </div>
    <ng-template #maximumMembersMessage>
      <div class="display-flex align-center">
        <div>
          <mat-icon svgIcon="x-icon" class="with-backgorund"></mat-icon>
        </div>
        <span class="max-members-message">
          <adp-label labelKey="Account_Manage_Members_MaxMemberMessage"></adp-label>
        </span>
      </div>
    </ng-template>
  </div>
  <mat-divider class="divider"></mat-divider>
  <div class="row no-gutters mt-20">
    <pgh-family-member-card
      *ngFor="let member of familyMemberList$ | async"
      class="col-6 col-sm-3"
      [familyMember]="member"
      [user]="user"
      [contract]="contract"
      (changeAvatarAction)="openEditAvatarModal($event)"
      (editAction)="openEditMemberDetailsModal($event)"
      (deleteAction)="openDeleteMemberModal($event)">
    </pgh-family-member-card>
  </div>
</div>
